module.exports = __webpack_public_path__ + "764532b5179e99754c7579d0cd8ffc28.pdf";